import React from "react";
import styles from "./DashboardIntroduction.module.scss";
import videoPoster from "../../../assets/onboarding.jpg";
import { Icon } from "../../../atoms/Icon";

function DashboardIntroduction({}) {
  return (
    <div>
      <h3 className={styles.heading}>Introduction To Video Squirrel</h3>

      <div className={styles.videoPlayer}>
        <video
          id="introVideo"
          className={styles.videoPlayerContainer}
          poster={videoPoster}
          src="https://www.w3schools.com/html/mov_bbb.mp4"
        ></video>
        <button className={styles.btnPlay}>
          <Icon name="play" color={"#fff"} size={24} />
        </button>
      </div>
      <div className={styles.desc}>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text
        </p>
      </div>

      <h3 className={styles.heading}>More</h3>

      <ul className={styles.articlesList}>
        <li className={styles.item}>
          <div className={styles.thumbnail}>
            <img src="https://source.unsplash.com/random" alt="" />
          </div>
          <div className={styles.contentHolder}>
            <h4 className={styles.title}>How to create opportunities</h4>
            <div className={styles.desc}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
        </li>

        <li className={styles.item}>
          <div className={styles.thumbnail}>
            <img src="https://source.unsplash.com/random" alt="" />
          </div>
          <div className={styles.contentHolder}>
            <h4 className={styles.title}>How to create opportunities</h4>
            <div className={styles.desc}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
        </li>

        <li className={styles.item}>
          <div className={styles.thumbnail}>
            <img src="https://source.unsplash.com/random" alt="" />
          </div>
          <div className={styles.contentHolder}>
            <h4 className={styles.title}>How to create opportunities</h4>
            <div className={styles.desc}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default DashboardIntroduction;
